module.exports = __webpack_public_path__ + "static/media/HorizonPdf.7558d0f8.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HorizonPdf.pdf
// module id = 1374
// module chunks = 1